// ─── Security guard (installed once at start-up — see src/index.js) ───────────
// 1. Live site: the app's console output is switched off, so F12 › Console shows no
//    business data, ids or rows. Real errors (console.error) still appear.
//    Support can switch full logging on for ONE browser: F12 › Application ›
//    Local Storage › add  barkah_debug = 1  and reload (remove it afterwards).
// 2. Every password field: the typed value is never written into the page's HTML
//    (React copies an input's value into its "value" attribute, which F12 › Elements
//    shows). The attribute is removed the moment it appears — typing is unaffected.

const QUIET = ['log', 'info', 'debug', 'trace', 'warn', 'table', 'dir', 'dirxml',
  'group', 'groupCollapsed', 'groupEnd', 'time', 'timeEnd', 'timeLog', 'count', 'countReset'];

function _debugOn() {
  try { return localStorage.getItem('barkah_debug') === '1'; } catch (_) { return false; }
}

function _isSecret(el) {
  return !!el && el.tagName === 'INPUT' && (String(el.type).toLowerCase() === 'password' || el.hasAttribute('data-sensitive'));
}
function _strip(el) {
  if (_isSecret(el) && el.hasAttribute('value')) el.removeAttribute('value');   // current text stays in the field
}
function _scan(node) {
  if (!node || node.nodeType !== 1) return;
  if (node.tagName === 'INPUT') { _strip(node); return; }
  if (node.querySelectorAll) node.querySelectorAll('input[value]').forEach(_strip);
}

export function installSecurityGuard() {
  if (typeof window === 'undefined' || window.__barkahGuard) return;
  window.__barkahGuard = true;

  // 1 — quiet console on the live site
  if (process.env.NODE_ENV === 'production' && !_debugOn()) {
    const noop = () => {};
    QUIET.forEach(k => { try { console[k] = noop; } catch (_) {} });
  }

  // 2 — password values never appear in the page HTML
  const start = () => {
    _scan(document.body);
    try {
      new MutationObserver(muts => {
        for (const m of muts) {
          if (m.type === 'attributes') _strip(m.target);
          else if (m.addedNodes) m.addedNodes.forEach(_scan);
        }
      }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'type'] });
    } catch (_) {}
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}

// Installs itself on import — imported FIRST in src/index.js so it runs before any other module
installSecurityGuard();
